import type { FaireProductEntity } from "../../entity_types/product";

export const p_cexyvusbvs: FaireProductEntity = {
  token: "p_cexyvusbvs",
  type: "product",
  name: "Pineapple Teak Wood Bowl",
  brandName: "Rainforest Bowls",
  imageUrl:
    "https://cdn.faire.com/fastly/1ee6192d9801f520afc215cc2f7dce7525a220af1cb6b49767359fe10e7222f3.jpeg",
  priceDollars: 15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/014490c47bb5fc0e93149a1905367b31769d4b9be0894fb8e3b281e198d96ef5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
